var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== null && _vm.value.start !== undefined && _vm.value.end !== undefined)?_c('div',{staticClass:"with-padding"},[_vm._v(" "+_vm._s(_vm.formatDateTime(_vm.value.start) + ' ' + _vm.$t('_.to') + ' ' + _vm.formatDateTime(_vm.value.end))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }